function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var AddonProductFilled = function AddonProductFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M22.909 3.137A2.14 2.14 0 0 0 20.77 1H7.026a2.14 2.14 0 0 0-2.138 2.137L4.887 4.33l-1.691.001A2.197 2.197 0 0 0 1 6.525v14.329c0 1.21.984 2.195 2.195 2.195h14.328a2.197 2.197 0 0 0 2.195-2.195v-1.833h1.052a2.14 2.14 0 0 0 2.138-2.138zM3.196 6.35h1.69l.002 10.534a2.14 2.14 0 0 0 2.138 2.138H17.7v1.833a.175.175 0 0 1-.176.175H3.196a.175.175 0 0 1-.176-.175V6.525c0-.097.078-.176.176-.176m10.703-1.18a1 1 0 0 1 1 1V9.01h2.84a1 1 0 0 1 0 2H14.9v2.841a1 1 0 0 1-2 0v-2.84h-2.841a1 1 0 0 1 0-2h2.84V6.168a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  }));
};
export default AddonProductFilled;